import React, { useState } from 'react';
import { Button, Tooltip, Spin } from 'antd';
import { CopyOutlined, CheckOutlined } from '@ant-design/icons';

const LotCopy = ({ lotNumber, size = 'small' }) => {
  const [copying, setCopying] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e.stopPropagation();

    if (!lotNumber) return;

    try {
      await navigator.clipboard.writeText(lotNumber);

      setCopying(true);

      setTimeout(() => {
        setCopying(false);
        setCopied(true);

        setTimeout(() => {
          setCopied(false);
        }, 2000);
      }, 500);
    } catch (error) {
      console.error('Failed to copy Lot Number:', error);
      setCopying(false);
    }
  };

  const iconSize = size === 'small' ? 14 : 18;

  return (
    <Tooltip title={copied ? 'Copied!' : 'Copy Lot Number'}>
      <Button
        type="text"
        size={size}
        icon={
          copying ? (
            <Spin size="small" />
          ) : copied ? (
            <CheckOutlined style={{ fontSize: iconSize, color: '#22c55e' }} />
          ) : (
            <CopyOutlined style={{ fontSize: iconSize }} />
          )
        }
        onClick={handleCopy}
        disabled={copying || !lotNumber}
        style={{
          marginLeft: 4,
          padding: '0 4px',
          minWidth: 28,
          height: 28,
          opacity: copying ? 0.7 : 1,
        }}
      />
    </Tooltip>
  );
};

export default LotCopy;
